import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { UnlockVoiceMessageResponse } from '@app/modules/messaging/models/api.model'
import type { Message } from '@app/modules/messaging/models/message.model'

export const voiceMessageEvents = eventGroup({
  source: 'Voice Message',
  events: {
    unlock: type<{
      message: Message & { type: 'voice'; status: 'locked' }
      profile_id: number
    }>(),
    unlockSuccess: type<{ response: UnlockVoiceMessageResponse }>(),
    unlockFailure: type<{
      error: any
      profile_id: number
    }>(),
    unlockEnd: type<{ messageTimestamp: Message['timestamp'] }>(),
  },
})
